/**
 * MODULE PAGE
 */

import { GetServerSideProps } from "next";
import { getSelectorsByUserAgent } from "react-device-detect";
import {
  getLearningApiClientFunctions,
  ILearning,
} from "@kunduz/data-access-learning-api";
import { serverSideTranslations } from "../../../common/utility/serverSideTranslations";
import ModulePage, {
  ModulePageProps,
} from "../../../domains/learning/pages/modulePage/modulePage";
import { getCachedHeaderItems } from "../../../common/services/cachedHeaderItems";
import { getCachedHeaderBanner } from "../../../common/services/cachedHeaderBanner";

export default function ModulePage_(props: ModulePageProps) {
  return (
    <ModulePage
      isMobile={props.isMobile}
      lang={props.lang}
      isAuth={props.isAuth}
      pageMeta={props.pageMeta}
      moduleSlug={props.moduleSlug}
      headerItems={props.headerItems}
      headerBanner={props.headerBanner}
    />
  );
}

export const getServerSideProps: GetServerSideProps = async ({
  req,
  res,
  query,
}) => {
  const { isMobile } = getSelectorsByUserAgent(req.headers["user-agent"]);

  const { kz_user_token } = req.cookies;
  const learningApiClientFunctions = getLearningApiClientFunctions();

  const pageMeta =
    await learningApiClientFunctions.getContentBySlug<ILearning.ModuleResponse>(
      "modules",
      query.moduleSlug as string,
    );

  if (!pageMeta) {
    return {
      notFound: true,
    };
  }

  const lang = "tr";
  const headerItems = await getCachedHeaderItems(lang, "student");
  const headerBanner = await getCachedHeaderBanner(lang);

  return {
    props: {
      isMobile,
      isAuth: !!kz_user_token,
      lang,
      pageMeta,
      headerItems,
      moduleSlug: query.moduleSlug,
      headerBanner,
      ...(await serverSideTranslations(lang, [
        "questionIndexing",
        "kunduzcom_learning",
        "kunduzcom_common",
      ])),
    },
  };
};
